import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { DeliveryRoadmap, Driver, Roadmap, Vehicle } from '../../../../logistics'
import { RoutePath, useRoutesHooks } from '../../../../../features/routes'
import { WidgetCard } from '../widget-card/widgetCard'
import { WidgetList, WidgetListRow } from '../widget-list/widgetList'

type Props = {
    loading: boolean
    error: boolean
    roadmaps: Roadmap[]
    roadmapLinks: DeliveryRoadmap[]
    drivers: Driver[]
    vehicles: Vehicle[]
}

export const RoadmapsTodayWidget = (props: Props) => {
    const { loading, error, roadmaps, roadmapLinks, drivers, vehicles } = props

    const { getRoutePath } = useRoutesHooks()
    const navigate = useNavigate()

    const rows = useMemo((): WidgetListRow[] => roadmaps.map(roadmap => {
        const deliveriesCount = roadmapLinks.filter(link => link.roadmapId === roadmap.id).length
        return {
            key: roadmap.id,
            label: `#${roadmap.code} ${drivers.find(driver => driver.id === roadmap.driverId)?.name || '-'}`,
            detail: vehicles.find(vehicle => vehicle.id === roadmap.vehicleId)?.name,
            value: `${deliveriesCount} entrega${deliveriesCount !== 1 ? 's' : ''}`,
            onClick: () => navigate(getRoutePath(RoutePath.ROADMAPS, roadmap.id))
        }
    }), [roadmaps, roadmapLinks, drivers, vehicles])

    return (
        <WidgetCard
            title={`Hojas de ruta de hoy (${roadmaps.length})`}
            loading={loading}
            error={error}
            empty={!loading && !error && rows.length === 0}
            emptyLabel="No hay hojas de ruta para hoy"
            linkLabel="Ver todas"
            linkPath={RoutePath.ROADMAPS}
        >
            <WidgetList rows={rows} maxRows={6} />
        </WidgetCard>
    )
}
